import { makeDocumentMockData } from '../../modules/documentMockDataFactory'
import type { IAccountDocument } from '~/types/document/models'

export const {
  getDocumentListData: getAccountDocumentListData,
  getDocumentDataById: getAccountDocumentDataById,
  getDocumentListDataByParentId: getAccountDocumentListDataByAccountId,
} = makeDocumentMockData<IAccountDocument>({
  entityName: 'account',
  storageKeyPrefix: 'account',
})
